import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"


export function useCampaignPDFExport(
    url,
    config = {},
) {
    return useAuthenticatedMutation(
        url,
        axiosInstance.post,
        {},
        {
            ...config,
            onSuccess: (data) => {
                config.onSuccess?.(data)
            },
        },
    )
}